import { useState, useEffect, useRef } from 'react';
import './EmailVerified.css';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from './services/api';

function VerifyEmail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    authAPI.verifyEmail(token)
      .then(() => {
        try {
          const stored = localStorage.getItem('user');
          if (stored) {
            const user = JSON.parse(stored);
            localStorage.setItem('user', JSON.stringify({ ...user, verified: true }));
            window.dispatchEvent(new Event('userUpdated'));
          }
        } catch {}
        setStatus('success');
      })
      .catch(() => setStatus('error'));
  }, [searchParams]);

  if (status === 'loading') {
    return (
      <div className="email-verified-container">
        <div className="email-verified-card">
          <p>{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="email-verified-container">
        <div className="email-verified-card">
          <div className="email-verified-icon" style={{ backgroundColor: '#e53935' }}>✕</div>
          <h1>{t('verifyEmail.errorTitle')}</h1>
          <p>{t('verifyEmail.errorMessage')}</p>
          <button className="email-verified-btn" style={{ backgroundColor: '#e53935' }} onClick={() => navigate('/')}>
            {t('emailVerified.goHome')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="email-verified-container">
      <div className="email-verified-card">
        <div className="email-verified-icon">✓</div>
        <h1>{t('emailVerified.title')}</h1>
        <p>{t('emailVerified.message')}</p>
        <button className="email-verified-btn" onClick={() => navigate('/')}>
          {t('emailVerified.goHome')}
        </button>
      </div>
    </div>
  );
}

export default VerifyEmail;